import React from 'react';
import {
  Paper, Typography, Table, TableHead, TableBody,
  TableRow, TableCell, Box, CircularProgress,
} from '@mui/material';

// Renders per-component reserved/issued/produced/scrapped figures.
// Either pass `rows` (array of aggregated tally rows) directly, or pass
// `movements` (raw ledger rows) and the panel will aggregate them via
// the same logic used in useTallyV2.

import { aggregateTally } from '../hooks/useTallyV2';

export default function MaterialTallyPanel({
  rows,
  movements,
  loading = false,
  title = 'Material Tally',
  emptyMessage = 'No movements yet.',
}) {
  const data = Array.isArray(rows)
    ? rows
    : aggregateTally(movements || []);

  return (
    <Paper variant="outlined" sx={{ p: 2 }} data-testid="material-tally-panel">
      <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
        {title}
      </Typography>
      {loading ? (
        <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
          <CircularProgress size={20} />
        </Box>
      ) : data.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          {emptyMessage}
        </Typography>
      ) : (
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Component</TableCell>
              <TableCell align="right">Reserved</TableCell>
              <TableCell align="right">Issued</TableCell>
              <TableCell align="right">Produced</TableCell>
              <TableCell align="right">Scrapped</TableCell>
              <TableCell align="right">Adjusted</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((r) => (
              <TableRow key={r.item_id} data-testid={`tally-row-${r.item_id}`}>
                <TableCell>{r.item_code || `#${r.item_id}`}</TableCell>
                <TableCell align="right">{Number(r.reserved || 0).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(r.issued || 0).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(r.produced || 0).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(r.scrapped || 0).toFixed(2)}</TableCell>
                <TableCell align="right">{Number(r.adjusted || 0).toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
}
